import type React from "react";
import { useState } from "react";
import type { IPredefinedAssetTemplate } from "app/pages/digital-suite/home-page/components/CustomAssets/types";
import { AssetContainer } from "app/pages/digital-suite/home-page/components/CustomAssets/Assets/styledComponents";
import {
    Title,
    ContentContainer,
    TextContainer,
    Text,
    CreationButton,
    Layout,
} from "app/pages/digital-suite/home-page/components/CustomAssets/Assets/PredefinedTemplate/styledComponents";

export const PredefinedAssetTemplate: React.FC<IPredefinedAssetTemplate> = ({
    hoverText,
    onClick,
    title,
    buttonText,
    content,
}) => {
    const [hovered, setHovered] = useState<boolean>(false);

    const showHovered = hovered && !!hoverText;

    return (
        <AssetContainer
            data-automation="predefined-asset-template"
            onMouseOver={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            onClick={onClick}
        >
            <Layout>
                <Title data-automation="predefined-asset-template-title">{title}</Title>
                <TextContainer isDisplayed={showHovered}>
                    <Text data-automation="predefined-asset-template-description">{hoverText}</Text>
                </TextContainer>
                <ContentContainer
                    data-automation="predefined-asset-template-content"
                    isDisplayed={!showHovered}
                >
                    {content}
                </ContentContainer>
                <CreationButton
                    data-automation="predefined-asset-template-cta"
                    className={`${hovered ? "hovered" : ""}`}
                    type={"flat"}
                    iconName={"plus"}
                    placement={"left"}
                    iconSize={"9px"}
                >
                    {buttonText}
                </CreationButton>
            </Layout>
        </AssetContainer>
    );
};
